export const MENU_CATEGORY_ORDER = [
    'jeux-video',
    'mangas',
    'jouets-goodies',
    'films-series',
    'ordinateur-de-jeu',
    'cartes',
    'bande-dessinee',
    'multimedia',
    'livres',
    'musique-c-d',
    'collection',
]
